export function formatPostalCodeAsYouType(rawValue: string): string {
  const digits = rawValue.replace(/\D/g, '').slice(0, 5);
  if (digits.length <= 2) {
    return digits;
  }
  return digits.slice(0, 2) + '-' + digits.slice(2);
}

export function formatDecimalAsYouType(rawValue: string): string {
  const cleaned = rawValue.replace(/[^0-9.]/g, '');
  const firstDotIndex = cleaned.indexOf('.');
  if (firstDotIndex === -1) {
    return cleaned;
  }
  const beforeDot = cleaned.slice(0, firstDotIndex);
  const afterDot = cleaned.slice(firstDotIndex + 1).replace(/\./g, '');
  return beforeDot + '.' + afterDot;
}

export function capitalizeWordsAsYouType(rawValue: string): string {
  return rawValue.replace(/(^|[\s-])(\p{L})/gu, function upper(match) {
    return match.toUpperCase();
  });
}
